import { render, staticRenderFns } from "./Modified.vue?vue&type=template&id=6d1f993a&scoped=true"
import script from "./Modified.vue?vue&type=script&lang=js"
export * from "./Modified.vue?vue&type=script&lang=js"
import style0 from "./Modified.vue?vue&type=style&index=0&id=6d1f993a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f993a",
  null
  
)

export default component.exports